module.exports = {"title":"Pin Position Statistics","selectGolfClub":"Select a golf club.","month1":"1 Month","month3":"3 Months","month6":"6 Months","tooltip":"Combined statistics for the searched period.","selectType":"Select a type."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cr101.json
// module id = fBzR
// module chunks = 2